export default {
    methods: {
        brandingImagesPath(path) {
            if (window.brand === 'usave') {
                return path.replace('/images/', '/images/brand/usave/');
            }

            return path;
        },
        requireCheckedIcon() {
            if (window.brand === 'usave') {
                return require('../Components/quotes/images/brand/usave/svgs/checkbox-rounded-checked.svg');
            }

            return require('../Components/quotes/images/svgs/checkbox-rounded-checked.svg')
        },
        requireUncheckedIcon() {
            if (window.brand === 'usave') {
                return require('../Components/quotes/images/brand/usave/svgs/checkbox-rounded-unchecked.svg');
            }

            return require('../Components/quotes/images/svgs/checkbox-rounded-unchecked.svg')
        },
        requireDownArrowIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/movemee/select-down-arrow.svg');
            }

            return require('../images/svgs/movemee/select-down-arrow.svg')
        },
        requireLightSwitchTickIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/toggle-switch-tick.svg');
            }

            return require('../images/svgs/toggle-switch-tick.svg')
        },
        requireVisaCardIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/cards/Visa.svg');
            }

            return require('../images/svgs/cards/Visa.svg')
        },
        requireMaestroCardIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/cards/Maestro.svg');
            }

            return require('../images/svgs/cards/Maestro.svg')
        },
        requireMasterCardIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/cards/MasterCard.svg');
            }

            return require('../images/svgs/cards/MasterCard.svg')
        },
        requireAmericaExpressCardIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/cards/American Express.svg');
            }

            return require('../images/svgs/cards/American Express.svg')
        },
        requireGreenTickIcon() {
            if (window.brand === 'usave') {
                return require('../images/brand/usave/svgs/green-tick.svg');
            }

            return require('../images/svgs/green-tick.svg')
        },
    },
};
